import { combineReducers } from 'redux';

import { requestOTPReducer } from "./request-otp";
import { verifyOTPReducer } from "./verify-otp";
import { verifyTokenReducer } from './verify-token';

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";



const tokenPesistConfig = {
    key: 'token',
    storage: storage,
    whitelist: ['access_token']
}

const userPesistConfig = {
    key: 'user',
    storage: storage,
    whitelist: ['data']
}

export default combineReducers({
    otp: requestOTPReducer,
    token: persistReducer(tokenPesistConfig, verifyOTPReducer),
    user: persistReducer(userPesistConfig, verifyTokenReducer)
});
